<template>
  <div class="document-creator">
    <popup-modal
      :top="popupStyle.top"
      v-model="currentValue"
      z-index="101"
      :body-style="popupStyle"
      use-height-change-transition
      class="document-creator"
    >
      <div class="modal-list-wrapper" :style="transformStyle">
        <div class="pre-select modal-wrapper">
          <div class="pre-select-inner half-px-border">
            <div class="left-area"></div>
            <div style="flex: 1">
              <div class="title half-px-border" v-if="!hasProxyFlag">
                {{ $t('main-1.key111', { cm: '快捷提单' }) }}
              </div>
              <div class="title proxy-user" v-else @click="showProxy = true">
                <div class="user-name">{{ currentSelectUser.name }}</div>
                <div class="user-type">{{ currentSelectUser.tips }}</div>
                <svg-icon class="user-icon" type="down" />
              </div>
            </div>
            <div class="right-area" @click.stop="close">
              <svg-icon type="close"></svg-icon>
            </div>
          </div>

          <div class="quick-creator-view">
            <div class="quick-form-list">
              <template v-if="isSingleSubmission">
                <template v-if="skipJob">
                  <div style="height: 0.08rem"></div>
                  <default-jobs
                    v-if="!isSingleJobFlag && currentApplicant && currentUserSelectJob"
                    :currentApplicant="currentApplicant"
                    :currentUserSelectJob="currentUserSelectJob"
                    @changeDefaultJob="changeDefaultJob"
                  >
                  </default-jobs>
                  <history-list-comp
                    :history-list="historyList"
                    @selectHistory="selectHistoryDocument"
                  ></history-list-comp>
                  <div class="document-title">{{ $t('main-1.key133', { cm: '创建单据' }) }}</div>
                  <template v-for="(item, index) in businessTypeList">
                    <create-list-item
                      :content="item.name"
                      :svg-icon="item.icon"
                      :svg-color="item.color"
                      :hasBorder="index + 1 < businessTypeList.length || thirdPartyAppList.length > 0"
                      @click.native="selectBusinessType(item)"
                    >
                    </create-list-item>
                  </template>
                  <template v-if="thirdPartyAppList.length > 0">
                    <create-list-item
                      :content="thirdPartyTitle"
                      :svg-icon="'_'"
                      :hasBorder="false"
                      @click.native="selectThirdParty()"
                    >
                    </create-list-item>
                  </template>
                </template>
                <template v-else>
                  <multi-job
                    :jobList="jobList"
                    :model="modelArray[0]"
                    :isSelf="currentSelectUser.self"
                    @multiJobEvent="multiJobEvent"
                  >
                  </multi-job>
                </template>
              </template>
              <template v-else>
                <div v-for="submission in submissionList" @click="selectSubmission(submission)">
                  <create-list-item :icon="submission.icon" :content="submission.name"> </create-list-item>
                </div>
              </template>
            </div>
            <quick-expense
              v-if="fetchFastApplicationEndFlag && createEnters.length > 0"
              :createEnters="createEnters"
              @selectCreateType="selectCreateType"
            >
            </quick-expense>
          </div>
          <!--<div class="popup-footer">
            <div class="cancel-button" @click.stop="close" v-click-feedback>
              {{ $t('common.key7', { cm: '取消' }) }}
            </div>
          </div>-->
        </div>

        <div
          class="modal-wrapper"
          v-for="(model, index) in operationArray"
          :key="model.mode"
          :class="{ 'border-right': index < operationArray.length - 1 }"
        >
          <div class="popup-header">
            <div class="left-arrow">
              <svg-icon type="left-v2" v-if="index >= 0" @click="goBack()"></svg-icon>
            </div>
            <div class="title">{{ model.title }}</div>
            <div class="right-arrow" v-if="false" @click="search(model.forbidSearching)">
              <img class="right-arrow-img" v-if="!model.forbidSearching" :src="images.search" />
            </div>
            <div class="right-arrow" v-else @click.stop="close">
              <svg-icon type="close"></svg-icon>
            </div>
          </div>
          <div class="popup-content">
            <div v-if="model.mode === 'job'">
              <multi-job
                :jobList="jobList"
                :model="model"
                :isSelf="currentSelectUser.self"
                @multiJobEvent="multiJobEvent"
              ></multi-job>
            </div>

            <div v-else-if="model.mode === 'businessType'">
              <default-jobs
                v-if="!isSingleJobFlag && currentApplicant && currentUserSelectJob"
                :currentApplicant="currentApplicant"
                :currentUserSelectJob="currentUserSelectJob"
                @changeDefaultJob="changeDefaultJob"
              >
              </default-jobs>
              <history-list-comp :history-list="historyList" @selectHistory="selectHistoryDocument"></history-list-comp>
              <div class="document-title">{{ $t('main-1.key133', { cm: '创建单据' }) }}</div>
              <template v-for="item in businessTypeList">
                <create-list-item
                  :content="item.name"
                  :svg-icon="item.icon"
                  :svg-color="item.color"
                  :hasBorder="index + 1 < businessTypeList.length || thirdPartyAppList.length > 0"
                  @click.native="selectBusinessType(item)"
                >
                </create-list-item>
              </template>
              <template v-if="thirdPartyAppList.length > 0">
                <create-list-item
                  :content="thirdPartyTitle"
                  :svg-icon="'_'"
                  :hasBorder="false"
                  @click.native="selectThirdParty()"
                >
                </create-list-item>
              </template>
            </div>

            <div v-else-if="model.mode === 'document'">
              <div v-for="(item, index) in documentList" @click="selectDocument(item)">
                <create-list-item
                  :description="item.hint"
                  :content="item.formName"
                  :hasBorder="index + 1 < documentList.length"
                >
                </create-list-item>
              </div>
              <div class="blank-viewer" v-if="!documentList.length">
                <div class="blank-icon">
                  <blank-svg></blank-svg>
                </div>
                <div class="blank-text">{{ $t('main-1.key112', { cm: '请联系管理员检查快捷提单数据权限' }) }}</div>
              </div>
            </div>
          </div>
          <!--div class="popup-footer">
            <img class="close-img" v-click-feedback @click.stop="close" :src="images.closeV4" />
          </div>-->
        </div>
      </div>
    </popup-modal>

    <popup-modal
      :top="popupStyle.top"
      v-model="showProxy"
      :isCustomClose="true"
      @customClose="showProxy = false"
      z-index="101"
      :body-style="popupStyle"
      use-height-change-transition
      class="select-user"
    >
      <div class="modal-wrapper">
        <div class="popup-header">
          <div class="left-arrow" @click="showProxy = false">
            <svg-icon type="left-v2"></svg-icon>
          </div>
          <div class="title">
            <div>{{ $t('main-1.key130', { cm: '选择申请人' }) }}</div>
          </div>
          <div class="right-arrow" @click="showProxy = false">
            <svg-icon type="close"></svg-icon>
          </div>
        </div>
        <div class="popup-content" style="text-align: left">
          <div class="current-user" @click="changeUser(getMyInfo, true)">
            <svg-icon class="checked-icon" type="check-outline" v-if="currentSelectUser.self"></svg-icon>
            {{ getMyInfo && getMyInfo.fullName }}
            <span class="user-type">{{ $t('main-1.key131', { cm: '本人' }) }}</span>
          </div>
          <div class="other-tips">{{ $t('main-1.key134', { cm: '代理他人' }) }}</div>
          <div class="other-content">
            {{ $t('main-1.key135', { cm: '小贴士：给他人创建单据，比如：秘书给老板提单据' }) }}
          </div>
          <div
            class="other-user"
            v-for="user in proxyUserList"
            v-if="user.userOID !== getMyInfo.userOID"
            @click="changeUser(user, false)"
          >
            <svg-icon
              class="checked-icon"
              type="check-outline"
              v-if="currentSelectUser.userOID === user.userOID"
            ></svg-icon>
            {{ user.fullName }}
          </div>
        </div>
      </div>
    </popup-modal>
  </div>
</template>
<script>
/**
 * @description: 新版首页快捷提单业务组件
 * @author: senlin.gu
 * @remark: TODO 缓存处理的还不够好，可以继续优化
 */
// 组件
import EmptyContent from 'components/base-ui/empty-content';
import PubListItem from 'components/base-ui/pub-list-item';
import HlyScroll from 'components/business/hly-scroll';
import Loading from 'components/base-ui/loading';
import PopupModal from 'components/base-ui/popup-modal';
import CreateListItem from './create-list-item';
import HistoryListComp from './history-list';
import QuicklyCreator from 'components/business/common/document-creator/quick-creator/index';
import MultiJob from 'components/business/common/document-creator/multi-job';
import DefaultJobs from 'components/business/common/document-creator/multi-job/default-job';
import QuickExpense from './quick-expense';
import blankSvg from './blank-svg';

// 图片
import backBlueImg from 'assets/images/application/subsidies-detail/back-blue@3x.png';
import searchImg from 'assets/images/common/search@3x.png';
import clearSearchImg from 'assets/images/common/clear-btn@2x.png';
import closeImg from 'assets/images/common/close-v2@2x.png';

import closeV3 from 'assets/images/common/close-v3.png';
import back from 'assets/images/common/back.png';
import search from 'assets/images/common/search.png';
import unChecked from 'assets/images/common/rounded-checkbox-blank@3x.png';
import checked from 'assets/images/common/rounded-checkbox@3x.png';
import closeV4 from 'assets/images/common/close-v2@2x.png';

import btnMicrophone from 'assets/images/application/voice/btn-microphone@3x.png';

// api
import documentCreatorHandler from './index.hander';
import commonQuickCreatorHandler from 'components/business/common/document-creator/index.handler';

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import { forbidScrollMixin, methodsMixin } from 'service/vue-mixin';
//import debounce from 'lodash.debounce';
import moment from 'moment';
import { getUserAvailableFormsV2, getUserSubmissionHistory } from 'api/common-document';
import Test from 'demo/document-edit/test';
import createExpenseImg from 'assets/images/refactor-main/create-expense@3x.png';
import { changeProtocolStatus, getFastCreate } from 'api/main';
import scanService from 'service/scanHandle';

export default {
  name: 'document-creator',
  mixins: [forbidScrollMixin, methodsMixin],
  /**
   * formType 表单类型，不传则需要选择表单类型，参考首页加号 101申请单 102报销单 104借款单 105付款申请单 111我的供应商
   * value 使用v-model绑定
   *
   * @input 修改value
   * @go-voice-record 语音功能，与原来一致
   * @will-create-document 监听此事件可用于记录何时发生表单创建，不用这个事件来做路由跳转
   */
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      images: {
        btnMicrophone,
        backBlueImg,
        searchImg,
        clearSearchImg,
        closeImg,
        unChecked,
        checked,
        closeV3,
        back,
        search,
        closeV4,
      },
      isSearchingMode: false,
      currentValue: false,
      keyword: '', //模糊查询字段
      searchResult: [], // 搜索结果
      historyList: [],
      historyListV2: [],
      applicantsList: [],
      jobsList: [],
      documentsList: [],
      currentApplicant: {},
      currentDocument: {},
      currentJob: {},
      // closingSearch: false,   // 用于确保搜索框收起时有动画,

      protocolStatus: {},
      fastCreateDisable: {
        application: true,
        expenseReport: true,
        expense: true,
        loanBill: true,
        contract: true,
        businessPayment: true,
        apRequest: true,
      },
      enableProtocol: {
        application: true,
        expenseReport: true,
        expense: true,
        loanBill: true,
        contract: true,
        businessPayment: true,
        apRequest: true,
      },
      protocol: {
        application: null,
        expenseReport: null,
        expense: null,
        loanBill: null,
        contract: null,
        businessPayment: null,
        apRequest: null,
      },
      userProtocol: {
        application: null,
        expenseReport: null,
        expense: null,
        loanBill: null,
        contract: null,
        businessPayment: null,
        apRequest: null,
      },

      clientWidth: undefined,
      currentFormType: '',
      currentMode: '',
      hasProxyAuth: false,
      hasMultiJobs: false,
      skipJobs: false,
      currentUserSelectJob: null,
      emptyImgStyle: {
        width: '64px',
        height: '64px',
      },
      recomDocumentList: [], // 推荐单据

      isSingleSubmission: false,
      skipJob: false,

      submissionList: [],
      jobList: [],
      businessTypeList: [],
      documentList: [],
      //currentApplicant: null,
      //currentUserSelectJob: null,
      currentSubmission: null,
      changeJobOrSelectBusinessType: '',
      currentBusinessType: null,
      isSingleJobFlag: false,
      thirdPartyAppList: [],
      thirdPartyTitle: window.$t('main-1.key113', { cm: '第三方应用' }),
      fetchFastApplicationEndFlag: false,

      hasProxyFlag: false,
      proxyUserList: [],
      currentSelectUser: {},
      showProxy: false,
    };
  },
  computed: {
    ...mapState(['proxyData']),
    ...mapGetters([
      'getProfile',
      'isInApp',
      'getMyInfo',
      'getAllApplicationList',
      'getUserInfo',
      'getUserToken',
      'getTenantProfile',
    ]),
    _hasPreSelect() {
      return !this.formType && !this.onlyJob;
    },
    isCorpBusiness() {
      return this.formType === '106';
    },
    modelArray() {
      return [
        {
          mode: 'job',
          title: window.$t('main-1.key114', { cm: '请选择申请人岗位' }),
          categoryList: this.jobsList,
          showKey: 'mainText',
          extraShowKey: ['extraText', 'duty', 'rank'],
          operationMethod: 'selectJob',
          searchPlaceholder: window.$t('global-1.key160', { cm: '按岗位查询' }),
          forbidSearching: true,
        },
        {
          mode: 'businessType',
          title: window.$t('main-1.key115', { cm: '请选择类型' }),
          operationList: this.documentsList,
          showKey: 'formName',
          operationMethod: 'selectDocument',
          searchPlaceholder: window.$t('global-1.key162', { cm: '按单据名称查询' }),
        },
        {
          mode: 'document',
          title:
            window.$t('common.key21', { cm: '请选择' }) +
            ((this.currentBusinessType && this.currentBusinessType.name) || ''),
          operationList: this.documentsList,
          showKey: 'formName',
          operationMethod: 'selectDocument',
          searchPlaceholder: window.$t('global-1.key162', { cm: '按单据名称查询' }),
        },
      ];
    },
    _modeArray() {
      let res = [];
      res.push('pre');
      this.processArray(
        res,
        this.isSingleSubmission,
        this.skipJob,
        this.changeJobOrSelectBusinessType,
        'job',
        'businessType',
        'document'
      );
      return res;
    },
    operationArray() {
      let res = [];
      this.processArray(
        res,
        this.isSingleSubmission,
        this.skipJob,
        this.changeJobOrSelectBusinessType,
        this.modelArray[0],
        this.modelArray[1],
        this.modelArray[2]
      );
      return res;
    },
    _modeIndex() {
      let { currentMode, _modeArray } = this;
      let index = _modeArray.indexOf(currentMode);
      return index === -1 ? 0 : index;
    },
    _formType() {
      let { formType, currentFormType } = this;
      return currentFormType || formType;
    },
    popupStyle() {
      let searching = this.isSearchingMode;
      let style = {
        borderTopRightRadius: '10px',
        borderTopLeftRadius: '10px',
        overflow: 'hidden',
        bottom: '0',
        top: '30%',
      };
      searching && (style.top = '0.3rem');
      return style;
    },
    showRequestTab() {
      return this.COMMON.getOption('corpExpRptControlSetting.displayPurchaseRequisition') !== false;
    },
    transformStyle() {
      let { clientWidth, _modeIndex } = this,
        transform = _modeIndex * clientWidth;
      return {
        transform: `translateX(-${transform}px)`,
        webkitTransform: `translateX(-${transform}px)`,
      };
    },
    isSelf() {
      let myInfo = this.$store.getters.getMyInfo;
      return this.currentApplicant && myInfo && this.currentApplicant.userOID === myInfo.userOID && !this.onlyJob;
    },
    createEnters() {
      let { fastCreateDisable, protocol, userProtocol, enableProtocol } = this;
      return [
        {
          name: window.$t('global-1.key168', { cm: '记一笔' }),
          icon: createExpenseImg,
          target: 'expense',
          appCode: 'EXPENSE_LIST',
          disable: fastCreateDisable.expense,
          protocol: protocol.expense,
          userProtocol: userProtocol.expense,
          enableProtocol: enableProtocol.expense,
        },
      ];
    },
  },
  watch: {
    keyword() {
      this.searchMethod();
    },
    value(val, old) {
      if (val) {
        //this.init(); // 在init中初始化currentValue
        this.currentValue = true;
      } else {
        val !== this.currentValue && (this.currentValue = val);
      }
    },
    currentValue: {
      handler(val, old) {
        val !== this.value && this.$emit('input', val);
        if (val) {
          this.init();
        } else {
          this.reset();
        }
      },
      immediate: true,
    },
    $route(to, from) {
      this.$plugins.hideLoading();
    },
  },
  methods: {
    ...mapMutations(['setNewApplyParam']),
    ...mapActions(['fetchProxyAuth', 'fetchMyProxyUser', 'fetchUserJobs', 'fetchUserAvailableForms']),
    changeUser(user, self) {
      if (user) {
        this.currentSelectUser = {
          name: user.fullName,
          userOID: user.userOID,
          self: self,
          tips: self ? window.$t('main-1.key131', { cm: '本人' }) : window.$t('main-1.key132', { cm: '他人' }),
        };
        this.showProxy = false;
        setTimeout(() => {
          this.$plugins.showLoading({
            type: 'FIXED',
          });
        }, 200);
        this.getInitData(user);
      }
    },
    processArray(res, isSingleSubmission, skipJob, changeJobOrSelect, job, businessType, document) {
      if (isSingleSubmission) {
        if (skipJob) {
          if (changeJobOrSelect === 'changeJob') {
            res.push(job);
          } else {
            res.push(document);
          }
        } else {
          res.push(businessType);
          res.push(document);
        }
      } else {
        if (skipJob) {
          res.push(businessType);
          if (changeJobOrSelect === 'changeJob') {
            res.push(job);
          } else {
            res.push(document);
          }
        } else {
          res.push(job);
          res.push(businessType);
          res.push(document);
        }
      }
    },
    selectSubmission(submission) {
      this.currentSubmission = submission;
      if (this.skipJob) {
        //this.getFormList(submission);
        //this.businessTypeList = submission.businessTypes;
        this.currentMode = 'businessType';
        this.businessTypeList = [];
        this.getAllFormListByJob();
      } else {
        this.currentMode = 'job';
      }
    },
    getFormListOld() {
      let submissionId = this.currentSubmission.id;
      let jobId = this.currentUserSelectJob.id;
      let businessTypeId = this.currentBusinessType.id;
      let userOID = this.$store.getters.getMyInfo.userOID;
      this.$plugins.showLoading({
        type: 'FIXED',
      });
      getUserAvailableFormsV2(userOID, submissionId, businessTypeId, jobId).then(
        (res) => {
          this.$plugins.hideLoading();
          if (res.status === 200) {
            //this.businessTypeList = documentCreatorHandler.processAvailableForms(res.data);
            this.documentList = res.data;
            if (this.documentList.length === 1) {
              //this.currentMode = 'document';
              this.selectDocument(this.documentList[0]);
            } else {
              this.currentMode = 'document';
            }
          }
        },
        (err) => {
          this.$plugins.hideLoading();
        }
      );
    },
    getFormList() {
      let businessTypeId = this.currentBusinessType.id;
      this.documentList = documentCreatorHandler.getUserAvailableFormsByBusinessType(businessTypeId);
      if (this.documentList.length === 1) {
        //this.currentMode = 'document';
        this.selectDocument(this.documentList[0]);
      } else {
        this.currentMode = 'document';
      }
    },
    getAllFormListByJob() {
      let submissionId = this.currentSubmission.id;
      let businessTypeList = this.currentSubmission.businessTypes;
      let jobId = this.currentUserSelectJob.id;
      let userOID = this.currentSelectUser.userOID;
      this.$plugins.showLoading({
        type: 'FIXED',
      });

      Promise.all([
        getUserAvailableFormsV2(userOID, submissionId, null, jobId),
        getUserSubmissionHistory(userOID, submissionId, jobId),
      ]).then(
        (res1) => {
          this.$plugins.hideLoading();
          if (res1[0].status === 200 && res1[0].data) {
            let formList = res1[0].data;
            let historyList = documentCreatorHandler.analyzeHistory(res1[1].data, submissionId);
            documentCreatorHandler.setAllAvailableFormList(formList);
            this.businessTypeList = documentCreatorHandler.getFilteredBusinessTypeList(formList, businessTypeList);
            this.historyList = historyList;
          }
        },
        (err) => {
          this.$plugins.hideLoading();
        }
      );
      /*getUserAvailableFormsV2(userOID, submissionId, null, jobId).then(
        (res) => {
          this.$plugins.hideLoading();
          if (res.status === 200 && res.data) {
            let formList = res.data;
            documentCreatorHandler.setAllAvailableFormList(formList);
            this.businessTypeList = documentCreatorHandler.getFilteredBusinessTypeList(formList, businessTypeList);
          }
        },
        (err) => {
          this.$plugins.hideLoading();
        }
      );*/
    },
    multiJobEvent(event) {
      if (event.type === 'select') {
        this.currentUserSelectJob = event.job;
        //this.getFormList(this.currentSubmission);
        this.businessTypeList = [];
        this.currentMode = 'businessType';
        this.getAllFormListByJob();
      } else if (event.type === 'default') {
        if (event.docDefault) {
          this.currentUserSelectJob = event.job;
          this.currentMode = 'businessType';
          this.businessTypeList = [];
          setTimeout(() => {
            this.getAllFormListByJob();
          }, 200);
          //this.getFormList(this.currentSubmission);
        } else {
          //
        }
      }
    },
    changeDefaultJob() {
      this.changeJobOrSelectBusinessType = 'changeJob';
      setTimeout(() => {
        this.currentMode = 'job';
      }, 200);
    },
    selectBusinessType(businessType) {
      this.changeJobOrSelectBusinessType = 'select';
      //this.documentList = businessType.documentList;
      this.currentBusinessType = businessType;
      this.getFormList();
    },
    selectThirdParty() {
      this.changeJobOrSelectBusinessType = 'select';
      this.documentList = this.thirdPartyAppList;
      this.currentBusinessType = {
        name: this.thirdPartyTitle,
      };
      this.currentMode = 'document';
    },
    selectHistoryDocument(history) {
      let appCodeKey = commonQuickCreatorHandler.getAppCodeByFormType(history.formType);
      this.$store.commit('setAppCodeKey', appCodeKey);
      documentCreatorHandler.createDocument({
        isExpense: false,
        document: history,
        formType: history.formType,
        applicant: this.currentApplicant,
        jobId: this.currentUserSelectJob.id,
        job: this.currentUserSelectJob,
        copy: false,
        copyDetail: {},
        setNewApplyParam: this.setNewApplyParam,
      });
    },
    selectDocument(document) {
      //console.log('selectDocument document', document);
      //console.log('selectDocument currentApplicant', this.currentApplicant);
      //console.log('selectDocument currentUserSelectJob', this.currentUserSelectJob);
      //console.log('selectDocument currentSubmission', this.currentSubmission);
      if (document.type === 'THIRD_PARTY') {
        let token = this.$store.getters.getUserToken && this.$store.getters.getUserToken.access_token;
        let url = document.link + `&access_token=${token}`;
        window.location.href = url;
        return;
      }
      let appCodeKey = commonQuickCreatorHandler.getAppCodeByFormType(document.formType);
      this.$store.commit('setAppCodeKey', appCodeKey);
      documentCreatorHandler.createDocument({
        isExpense: false,
        document,
        formType: document.formType,
        applicant: this.currentApplicant,
        jobId: this.currentUserSelectJob.id,
        job: this.currentUserSelectJob,
        copy: false,
        copyDetail: {},
        setNewApplyParam: this.setNewApplyParam,
      });
    },

    selectCreateType(type) {
      let { appCode } = type;
      if (this.protocolStatus[appCode] && type.enableProtocol) {
        if (!type.userProtocol || type.userProtocol.status === 'N') {
          this.$handPlugin.confirm.show({
            title: type.protocol.protocolName,
            content: type.protocol.protocolContent,
            leftButtonText: window.$t('global-1.key169', { cm: '不同意' }),
            rightButtonText: window.$t('global-1.key170', { cm: '同意并继续' }),
            titleStyle: { textAlign: 'left' },
            textStyle: { maxHeight: '4.5rem', overflow: 'auto', textAlign: 'left' },
            leftClick: () => {},
            rightClick: () => {
              changeProtocolStatus(appCode, 'Y')
                .then((res) => {
                  this.protocolStatus[appCode] = false;
                  this.differentCreateType(type.target, type);
                })
                .catch((err) => {});
            },
          });
        } else {
          this.differentCreateType(type.target, type);
        }
      } else {
        this.differentCreateType(type.target, type);
      }
    },
    differentCreateType(target, type) {
      if (target === 'expense') {
        this.close();
        setTimeout(() => {
          this.$store.commit('setAppCodeKey', 'EXPENSE_LIST');
          this.hlyRouter.push({
            name: 'expense-create',
            params: {
              mode: 'create',
            },
          });
        }, 300);
      } else if (target === 'ocr-event') {
        this.close();
        setTimeout(() => {
          this.$store.commit('setAppCodeKey', 'EXPENSE_LIST');
          this.hlyRouter.push({
            name: 'expense-list',
            query: {
              directOCR: 'Y',
            },
            params: {
              directOCR: 'Y',
            },
          });
        }, 300);
      } else if (target === 'invoice-scan') {
        this.close();
        setTimeout(() => {
          this.$store.commit('setAppCodeKey', 'EXPENSE_LIST');
          scanService.scanToExpense(this.hlyRouter, this.$handPlugin);
        }, 300);
      }
    },

    //上一步
    goBack() {
      let { _modeArray, _modeIndex } = this,
        newIndex = _modeIndex - 1;
      newIndex < 0 && (newIndex = 0);
      switch (this.currentMode) {
        case 'job':
          //this.currentApplicant = {};
          break;
        case 'business':
          //this.currentApplicant = {};
          break;
        case 'document':
          if (this.hasMultiJobs) {
            //this.currentJob = {};
          } else {
            //this.currentApplicant = {};
          }
          break;
        default:
          break;
      }
      this.currentMode = _modeArray[newIndex];
      if (this.currentMode === 'pre') {
        let defaultJob = documentCreatorHandler.getDefaultJob(this.jobList);
        if (defaultJob) {
          this.currentUserSelectJob = defaultJob;
          this.skipJob = true;
        } else {
          this.skipJob = false;
        }
      }
    },
    close() {
      this.currentValue = false;
    },
    /**
     * @description: 初始化方法，loading，默认值等处理
     * @create: senlin.gu
     * @remark: 将一些纯数据处理的逻辑通过JS API，将交互与数据处理分开处理
     */
    init() {
      this.submissionList = [];
      this.businessTypeList = [];
      let myInfo = this.getMyInfo;
      //console.log('documentCreatorHandler this.getAllApplicationList ', this.getAllApplicationList);
      this.thirdPartyAppList = documentCreatorHandler.processThirdParty(this.getAllApplicationList);
      setTimeout(() => {
        this.$plugins.showLoading({
          type: 'FIXED',
        });
      }, 200);
      documentCreatorHandler.getProxyUserInfoApi((res) => {
        this.hasProxyFlag = res.hasProxyFlag;
        this.proxyUserList = res.proxyUserList;
      });
      this.currentSelectUser = {
        name: myInfo.fullName,
        userOID: myInfo.userOID,
        self: true,
        tips: window.$t('main-1.key131', { cm: '本人' }),
      };
      //console.log('this.currentSelectUser', this.currentSelectUser)
      this.getInitData(myInfo, true);
      getFastCreate().then((res) => {
        if (res.data) {
          this.fetchFastApplicationEndFlag = true;
          let data = res.data;
          data.forEach((item) => {
            this.protocolStatus[item.appCode] = item.enableProtocol;
            if (item.appCode === 'EXPENSE_LIST') {
              this.fastCreateDisable.expense = false;
              this.protocol.expense = item.protocol;
              this.userProtocol.expense = item.userProtocol;
              this.enableProtocol.expense = item.enableProtocol;
            }
          });
        }
      });
    },
    getInitData(user, initFlag) {
      documentCreatorHandler.getInitData(user, this.thirdPartyAppList, initFlag).then(
        (res) => {
          //console.log('documentCreatorHandler res ', res);
          //console.log('documentCreatorHandler submissionList ', res.submissionList);
          //console.log('documentCreatorHandler jobList ', res.jobList);
          //console.log('documentCreatorHandler defaultJob ', res.defaultJob);
          //console.log('documentCreatorHandler defaultSubmission ', res.defaultSubmission);
          setTimeout(() => {
            this.$plugins.hideLoading();
          }, 200);

          this.submissionList = res.submissionList;
          this.businessTypeList = res.businessTypeList;
          this.jobList = res.jobList;
          this.currentApplicant = res.applicant;
          this.currentUserSelectJob = res.defaultJob;
          this.currentSubmission = res.defaultSubmission;
          this.historyList = res.historyList;
          this.isSingleJobFlag = res.isSingleJobFlag;

          if (res.defaultJob) {
            this.skipJob = true;
          }
          if (res.defaultSubmission) {
            this.isSingleSubmission = true;
          }
        },
        () => {
          setTimeout(() => {
            this.$plugins.hideLoading();
          }, 200);
        }
      );
    },
    search() {},
    reset() {
      this.currentUserSelectJob = null;
      this.currentApplicant = {};
      this.currentDocument = {};
      this.currentJob = {};
      this.currentMode = '';
      this.currentFormType = '';
      this.isSearchingMode = false;
      this.keyword = '';
      this.searchResult = [];
      this.historyList = [];
      this.historyListV2 = [];
      this.applicantsList = [];
      this.jobsList = [];
      this.documentsList = [];
    },
    format(value, type) {
      if (type === 'date') {
        return moment(value).format('YYYY-MM-DD');
      } else if (type === 'amount') {
        return value
          .toFixed(2)
          .toString()
          .replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
      }
    },
  },
  created() {
    this._removeForbidClass();
    this.clientWidth = window.innerWidth || document.body.clientWidth;
  },
  mounted() {
    this.$nextTick(() => {
      this._addForbidClass();
    });
  },
  beforeDestroy() {
    this._reduceForbidClass();
  },

  components: {
    Test,
    DefaultJobs,
    QuicklyCreator,
    EmptyContent,
    PubListItem,
    HlyScroll,
    Loading,
    PopupModal,
    MultiJob,
    CreateListItem,
    HistoryListComp,
    QuickExpense,
    blankSvg,
  },
};
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
@import '~assets/css/variable.scss';

.popup-wrapper {
  &.search-mode {
    transition: height 0.3s ease-in-out;
  }
}

.document-creator {
  .half-px-border:after {
    background: #ededed;
  }
}

.modal-list-wrapper {
  display: flex;
  width: 400vw;
  height: 100%;
  transition: transform 0.3s ease-in-out;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  overflow: hidden;

  .document-title {
    font-style: normal;
    font-weight: 400;
    font-size: 28px;
    line-height: 40px;
    color: #969aa2;
    margin-bottom: 10px;
    text-align: left;
    padding-left: 32px;
  }
}

.pre-select {
  .pre-select-inner {
    display: flex;
    align-items: center;
    padding: 0 44px;
  }
  .title {
    padding: 32px 0;
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 32px;
    line-height: 44px;
    text-align: center;
    color: #505564;
  }

  .left-area {
    width: 100px;
  }

  .right-area {
    width: 100px;
    text-align: right;
    color: #9d9d9d;
  }

  .proxy-user {
    display: flex;
    justify-content: center;
    align-items: center;
    .user-name {
      font-style: normal;
      font-weight: 500;
      font-size: 32px;
      height: 48px;
      line-height: 48px;
      color: #252629;
      margin-right: 8px;
    }
    .user-type {
      font-style: normal;
      font-weight: 400;
      font-size: 24px;
      line-height: 36px;
      color: #969aa2;
      background: #f2f2f3;
      border-radius: 4px;
      margin-right: 8px;
      padding: 8px;
    }
  }

  background: #fff;

  .quick-creator-view {
    height: calc(100% - 0.7rem);
    display: flex;
    flex-direction: column;
    .quick-form-list {
      flex: 1;
      overflow-y: auto;
      margin-bottom: px(20);
      border-bottom: 1px solid #ebedef;
    }

    .quick-menu-list {
      display: flex;
      align-items: center;
      padding: px(20) 0;

      &.maintenance {
        .quick-menu-icon,
        .quick-menu-text {
          opacity: 0.6;
        }
      }

      .quick-menu-item {
        flex: 1;
        display: flex;

        .quick-menu-item-inner {
          display: flex;
          align-items: center;
          margin-left: auto;
          margin-right: auto;
          position: relative;

          .maintenance-icon {
            top: -0.1rem;
            left: 0.1rem;
            position: absolute;
            width: px(32);
            height: px(32);
          }

          .quick-menu-icon {
            width: px(48);
            height: px(48);
          }
          .quick-menu-text {
            padding-left: px(16);
            font-family: PingFangSC-Regular;
            font-size: px(28);
            color: #505564;
            letter-spacing: 0;
            line-height: px(28);
          }
        }
      }
    }
  }

  .create-enter-wrapper {
    height: px(270);
    width: calc(100vw - #{px(60)});
    margin-top: px(20);
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 0 px(30);

    .create-item {
      display: flex;
      flex-direction: column;
      align-items: center;

      .create-item-icon {
        width: px(120);
        margin-bottom: px(20);
      }

      .create-item-name {
        font-family: PingFangSC-Regular;
        font-size: px(28);
        color: #505564;
        text-align: center;
      }
    }
  }

  .latest-doc-title {
    height: px(64);
    width: 100vw;
    text-align: center;
    font-family: PingFangSC-Regular;
    font-size: px(28);
    color: #8c96b4;
    line-height: px(64);
    background: #f8f8f8;
  }

  .popup-content.latest-doc-wrapper {
    /*px(270) + px(20) + px(64) + px(88)*/
    height: calc(100% - #{px(522)});
  }
}

.select-user {
  .current-user {
    position: relative;
    font-style: normal;
    font-weight: 400;
    font-size: 28px;
    line-height: 44px;
    color: #252629;
    padding: 32px;
    border-bottom: 1px solid #f2f2f3;
    .checked-icon {
      position: absolute;
      right: 32px;
      color: #0f62fe;
      font-size: 32px;
    }
    .user-type {
      background: #f2f2f3;
      border-radius: 4px;
      height: 36px;
      line-height: 36px;
      font-style: normal;
      font-weight: 400;
      font-size: 24px;
      color: #969aa2;
      padding: 8px;
    }
  }
  .other-tips {
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 500;
    font-size: 28px;
    line-height: 44px;
    color: #252629;
    margin-top: 40px;
    padding-left: 32px;
  }
  .other-content {
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 24px;
    line-height: 36px;
    color: #000000;
    padding: 16px 32px;
    margin-top: 8px;
    background: #f9f9f9;
    .checked-icon {
      position: absolute;
      right: 32px;
      color: #0f62fe;
      font-size: 32px;
    }
  }
  .other-user {
    position: relative;
    font-style: normal;
    font-weight: 400;
    font-size: 28px;
    line-height: 44px;
    color: #252629;
    padding: 32px;
    border-bottom: 1px solid #f2f2f3;
  }
}

.modal-wrapper {
  height: 100%;
  overflow: hidden;
  width: 100vw;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  background: #fff;

  .select-model {
    background: #fff;
    height: 100%;
    overflow: hidden;
    width: 100%;
  }

  .search-model {
    height: 100%;
    overflow: hidden;
    background: #ebecef;
    width: 100%;
  }

  &.border-right {
    position: relative;

    &:before {
      content: '';
      width: 2px;
      height: 100%;
      position: absolute;
      bottom: 0;
      left: 0;
      background: #d7dce6;
      transform-origin: 0 0;
      transform: scaleX(0.5);
    }
  }

  .popup-header-search {
    padding-bottom: px(10);

    .base-search-head {
      height: px(100);
      background: #fff;
      display: flex;
      align-items: center;
      &.ignore-rem {
        padding: 0 10px;
      }

      &.border-bottom {
        border-bottom: 2px solid #d7dce6;
      }

      .base-search-body {
        flex-grow: 1;
        height: px(60);
        font-size: px(24);
        color: #8c96b4;
        background: #ebedef;
        border-radius: px(80);
        display: flex;
        align-items: center;
        width: min-content;
        // 750px/20px => rem/10px，现在不需要转rem直接缩小一倍
        &.ignore-rem {
          padding: 0 10px;
        }
      }

      .search-icon {
        width: px(28);
        height: px(28);
        margin-right: px(10);
      }

      .search-input-area {
        background: inherit;
        font: inherit;
        border: none;
        outline: none;
        width: calc(100% - #{px(28)});
      }

      .clear-search-icon {
        width: px(24);
        height: px(24);
        padding: px(4);
        padding-left: px(10);
      }
    }

    .cancel-search-button {
      color: $mainColor;
      font-size: px(32);
      &.ignore-rem {
        padding: 5px 0 5px 10px;
      }
    }
  }

  .input-style {
    flex: 8;
    color: #1e3255;

    .search-input {
      width: 96%;
      border: 2px solid #ddd;
      height: 60px;
      margin: 6px 2%;
      padding-left: 10px;
      background: #fff;
      position: relative;
      outline: none;
    }

    .clear {
      position: absolute;
      top: 30px;
      width: 30px;
      right: 15%;
    }
  }

  .left-arrow {
    width: px(100);
    color: #9d9d9d;
    font-size: 32px;
    height: 40px;

    .go-back {
      flex: 1;
      display: flex;
      align-items: center;

      .go-back-img {
        width: px(40);
      }
    }
  }

  .title {
    flex: 1;
    color: #505564;
    font-size: px(32);
    text-align: center;
  }

  .right-arrow {
    width: px(100);
    position: relative;
    color: #9d9d9d;
    text-align: right;
    font-size: 36px;
    height: 40px;

    .right-arrow-img {
      width: px(36);
      height: px(36);
    }
  }

  .popup-header {
    padding: 0 44px;
    height: px(110);
    display: flex;
    align-content: center;
    align-items: center;
    position: relative;

    &::after {
      content: '';
      display: block;
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 2px;
      background: #d7dce6;
      -webkit-transform: scaleY(0.5);
      transform: scaleY(0.5);
      -webkit-transform-origin: 0 0;
      transform-origin: 0 0;
    }
  }

  .popup-content,
  .popup-content-search {
    position: relative;
    height: calc(100% - #{px(168)});
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    //-webkit-backface-visibility: hidden;
    //transform: translate3d(0, 0, 0);
    text-align: center;
    width: 100%;
    padding: 0;
    color: #505564;
    background: #fff;

    .blank-viewer {
      .blank-icon {
        height: 240px;
        width: 240px;
        margin: 0 auto;
        padding-top: 100px;
      }
      .blank-text {
        margin-top: 20px;
        font-weight: 400;
        font-size: 28px;
        line-height: 28px;
        color: #adadad;
        text-align: center;
      }
    }

    .default-jobs {
      //padding: px(30) px(40);
      //background: #f8f8f8;
      //text-align: left;

      .jobs {
        font-family: PingFangSC-Regular;
        font-size: px(28);
        color: #505564;
        letter-spacing: 0;
        line-height: px(28);
        display: flex;
        width: 85%;

        .position {
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }

        .default-text {
          padding: px(2) px(10);
          background: #e9e9e9;
          border-radius: 4px;
          font-family: PingFangSC-Regular;
          font-size: px(22);
          color: #8c96b4;
          letter-spacing: 0;
          line-height: 1;
          margin-left: px(10);
          white-space: nowrap;
        }
      }

      .company {
        margin-top: px(16);
        margin-right: px(75);
        font-family: PingFangSC-Regular;
        font-size: px(24);
        color: #8c96b4;
        line-height: px(24);
      }

      .change-job {
        position: absolute;
        right: px(40);
        top: px(40);
        font-family: PingFangSC-Regular;
        font-size: px(24);
        color: #505564;
        line-height: px(28);
      }
    }

    .list-item {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      position: relative;
      font-size: px(30);
      padding: px(30) px(40);

      &::after {
        content: '';
        display: block;
        position: absolute;
        left: px(30);
        bottom: 0;
        width: calc(100% - #{px(60)});
        height: 2px;
        background: #d7dce6;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
      }

      &.has-voice-input .list-row {
        /* 100 * 2 + 4 避免与录音按钮重叠*/
        width: calc(100% - #{px(204)});
      }

      .list-row {
        width: 100%;
        flex-shrink: 0;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-family: PingFangSC-Medium;
        font-size: px(32);
        color: #0a0f1e;
      }

      .list-item-inner {
        text-align: left;
        width: 100%;

        .list-item-inner2 {
          text-align: left;
          width: 100%;

          &.show-default {
            width: 80%;
          }
        }
      }

      .default-job {
        position: absolute;
        top: 0;
        right: px(40);
        bottom: 0;

        .default-job-inner {
          display: flex;
          height: 100%;
          align-items: center;

          .check-img {
            width: px(28);
            height: px(28);
          }

          .text {
            font-family: PingFangSC-Regular;
            font-size: px(26);
            color: #505564;
            line-height: px(28);
            margin-left: px(12);
          }
        }
      }

      .extra-text {
        font-family: PingFangSC-Regular;
        font-size: px(24);
        color: #8c96b4;
      }
    }

    .voice-wrapper {
      width: px(50);
      height: px(50);
      position: absolute;
      right: px(0);
      background: #fff;
      border-left: 2px solid #d7dce6;
      padding: 0 px(25);
    }

    .category-name {
      background: $boxGroundingColor;
      height: px(64);
      font-family: PingFangSC-Regular;
      font-size: px(30);
      line-height: px(64);
      color: #8c96b4;
      text-align: left;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      padding: 0 px(40);
    }
  }

  .popup-content {
    padding-top: 32px;
  }

  .popup-content.has-expense-item {
    text-align: left;
    .document-title {
      background-color: #f3f6f9;
      color: #71757e;
      padding: px(8) px(32);
      line-height: px(40);
      font-size: px(26);
    }
    .recommend-document {
      .recommend-item {
        padding: px(32);
        &.not-last {
          border-bottom: solid px(2) #f2f2f3;
        }
        .formName,
        .createDate {
          display: inline-block;
          font-size: px(32);
          line-height: px(48);
          color: #252629;
          font-weight: bold;
        }
        .title,
        .amount {
          display: inline-block;
          font-size: px(20);
          line-height: px(32);
          color: #71757e;
        }
        .createDate,
        .amount {
          float: right;
        }
        .formName {
          max-width: 70%;
        }
        .mark-and-amount {
          display: flex;
          align-items: center;
          .title {
            flex: 1;
            text-align: left;
          }
        }
      }
    }
  }

  .popup-content-search {
    max-height: calc(100% - #{px(110)});
    height: auto;
    background: #fff;

    .list-item:last-of-type::after {
      display: none;
    }
  }

  .bscroll {
    height: calc(100% - #{px(110)});
    padding: 0 px(20);
  }

  .relate-item-wrapper {
    margin-bottom: px(10);
  }

  .popup-footer {
    position: relative;
    bottom: 0;
    height: px(180);
    display: flex;
    align-items: center;
    touch-action: none;

    .cancel-button {
      //font-family: 'PingFang SC';
      font-style: normal;
      font-weight: 500;
      font-size: 32px;
      line-height: 80px;
      text-align: center;
      color: #505564;
      width: 100%;
      border: 0.5px solid #d7dce6;
      box-sizing: border-box;
      border-radius: 4px;
      margin: 20px 40px;
    }

    /*&::before {
        content: "";
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 2px;
        background: #D7DCE6;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
      }*/

    .close-img {
      margin-left: auto;
      margin-right: auto;
      width: px(40);
      height: px(40);
    }
  }
}
</style>
